import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import abedalslam from "../../Images/abedalslam.png";
import call from "../../Images/call.png";
import Bokahitlogo2nobgc from "../../Images/Bokahitlogo2nobgc.png";
import whatsapp from "../../Images/whatsapp.png";
import { useAppContext } from "../../AppContext";
import { useParams } from "react-router-dom";

export default function MPHomeFirstBlock() {
  const history = useHistory();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { AllData, WazeData } = useAppContext();
  const { BarberPhoneNumber } = useParams();
  const screenHeight = window.screen.height;
  const [hoveredButton, setHoveredButton] = useState(null);
  const [shareHovered, setShareHovered] = useState(false);
  const [backHovered, setBackHovered] = useState(false);
  const [address, setAddress] = useState("Loading location...");

  // Fetch address from coordinates
  useEffect(() => {
    const getAddressFromCoordinates = async (lat, lng) => {
      const apiKey = "AIzaSyA4HcCM2bP0v8Chi2bdFL7vAhCVkepKsBY";
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        if (data.results[0]) {
          const addressComponents = data.results[0].address_components;
          const street =
            addressComponents.find((c) => c.types.includes("route"))
              ?.long_name || "";
          const city =
            addressComponents.find((c) => c.types.includes("locality"))
              ?.long_name || "";

          return street && city
            ? `${street}, ${city}`
            : data.results[0].formatted_address;
        }
        return "Location not available";
      } catch (error) {
        console.error("Error fetching address:", error);
        return "Location not available";
      }
    };

    const fetchAddress = async () => {
      const lat = WazeData?.lat;
      const lng = WazeData?.long;

      if (lat && lng) {
        const locationAddress = await getAddressFromCoordinates(lat, lng);
        setAddress(locationAddress);
      } else {
        setAddress("Location not available");
      }
    };

    fetchAddress();
  }, [WazeData]);

  const handleBack = () => {
    history.goBack(); // Goes back to previous page
  };

  const handleGoogleMaps = () => {
    const lat = WazeData?.lat;
    const lng = WazeData?.long;

    if (!lat || !lng) {
      alert("Location not available");
      return;
    }
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    window.open(url, "_blank");
  };

  const handleCall = () => {
    window.location.href = `tel:${AllData.barberData.countryNumber}${AllData.barberData.phoneNumber}`;
  };

  const handleWhatsApp = () => {
    window.open(
      `https://wa.me/${AllData.barberData.countryNumber}${AllData.barberData.phoneNumber}`,
      "_blank",
    );
  };

  const handleShare = async () => {
    const shareUrl = window.location.href;

    if (navigator.share) {
      try {
        await navigator.share({
          title: `${AllData.barberData.name}'s Profile`,
          text: `Check out ${AllData.barberData.name}'s barbershop`,
          url: shareUrl,
        });
      } catch (err) {
        if (err.name !== "AbortError") {
          fallbackShare(shareUrl);
        }
      }
    } else {
      fallbackShare(shareUrl);
    }
  };

  const fallbackShare = (url) => {
    navigator.clipboard.writeText(url).then(
      () => {
        alert("Link copied to clipboard!");
      },
      () => {
        alert("Failed to copy link");
      },
    );
  };

  const styles = {
    container: {
      position: "relative",
      display: "flex",
      width: "100%",
      minHeight: screenHeight / 2.8,
      alignItems: "center",
      justifyContent: "center",
      borderBottomLeftRadius: "32px",
      borderBottomRightRadius: "32px",
      flexDirection: "column",
      overflow: "hidden",
      background: "linear-gradient(160deg, #1A1A2E 0%, #16213E 60%, #0F3460 100%)",
      boxShadow: "0 10px 40px rgba(0,0,0,0.35)",
      paddingBottom: "50px",
      paddingTop: "30px",
    },
    backButton: {
      position: "absolute",
      top: "20px",
      left: "20px",
      zIndex: 2,
      width: "48px",
      height: "48px",
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      border: "none",
      borderRadius: "16px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      boxShadow: backHovered
        ? "0 8px 24px rgba(0,0,0,0.25)"
        : "0 4px 12px rgba(0,0,0,0.15)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      transform: backHovered ? "scale(1.1)" : "scale(1)",
    },
    shareButton: {
      position: "absolute",
      top: "78px",
      left: "20px",
      zIndex: 2,
      width: "48px",
      height: "48px",
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      border: "none",
      borderRadius: "16px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      boxShadow: shareHovered
        ? "0 8px 24px rgba(0,0,0,0.25)"
        : "0 4px 12px rgba(0,0,0,0.15)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      transform: shareHovered ? "scale(1.1)" : "scale(1)",
    },
    backIcon: {
      width: "24px",
      height: "24px",
      fill: "#C9A84C",
    },
    shareIcon: {
      width: "24px",
      height: "24px",
      fill: "#C9A84C",
    },
    backgroundOverlay: {
      position: "absolute",
      inset: 0,
      background:
        "radial-gradient(circle at 30% 50%, rgba(255,255,255,0.15) 0%, transparent 60%)",
      zIndex: 0,
    },
    backgroundPattern: {
      position: "absolute",
      inset: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      zIndex: 0,
      opacity: 0.4,
    },
    contentWrapper: {
      position: "relative",
      zIndex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "24px",
      padding: "0 20px",
      maxWidth: "600px",
      width: "100%",
    },
    imageContainer: {
      position: "relative",
      padding: "5px",
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)",
      borderRadius: "28px",
      boxShadow:
        "0 12px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(255,255,255,0.3)",
      transition: "transform 0.3s ease",
    },
    profileImage: {
      width: "140px",
      height: "140px",
      borderRadius: "24px",
      objectFit: "cover",
      display: "block",
      border: "3px solid rgba(255,255,255,0.5)",
    },
    placeholderAvatar: {
      width: "140px",
      height: "140px",
      borderRadius: "24px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "56px",
      fontWeight: "700",
      color: "#fff",
      background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      border: "3px solid rgba(255,255,255,0.5)",
      textShadow: "0 2px 8px rgba(0,0,0,0.2)",
      userSelect: "none",
    },
    textContainer: {
      textAlign: "center",
      color: "#fff",
    },
    name: {
      fontSize: "28px",
      fontWeight: "700",
      margin: "0 0 8px 0",
      textShadow: "0 2px 8px rgba(0,0,0,0.3)",
      letterSpacing: "-0.02em",
      lineHeight: "1.2",
    },
    location: {
      fontSize: "15px",
      margin: "0 0 4px 0",
      opacity: 0.9,
      fontWeight: "400",
      textShadow: "0 1px 4px rgba(0,0,0,0.2)",
      letterSpacing: "0.01em",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
    },
    phone: {
      fontSize: "16px",
      margin: 0,
      opacity: 0.95,
      fontWeight: "500",
      textShadow: "0 1px 4px rgba(0,0,0,0.2)",
      letterSpacing: "0.02em",
    },
    buttonsContainer: {
      display: "flex",
      gap: "20px",
      flexWrap: "wrap",
      justifyContent: "center",
    },
    actionButton: (isHovered) => ({
      width: "64px",
      height: "64px",
      backgroundColor: "#fff",
      border: "none",
      borderRadius: "20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      boxShadow: isHovered
        ? "0 8px 24px rgba(0,0,0,0.25)"
        : "0 6px 16px rgba(0,0,0,0.15)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      transform: isHovered
        ? "translateY(-4px) scale(1.05)"
        : "translateY(0) scale(1)",
      position: "relative",
      overflow: "hidden",
    }),
    buttonIcon: {
      width: "36px",
      height: "36px",
      position: "relative",
      zIndex: 1,
      transition: "transform 0.3s ease",
    },
    buttonRipple: {
      position: "absolute",
      inset: 0,
      background:
        "radial-gradient(circle, rgba(0,0,0,0.05) 0%, transparent 70%)",
      opacity: 0,
      transition: "opacity 0.3s ease",
    },
  };

  const GoogleMapsIcon = () => (
    <svg width="36" height="36" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg">
      <path fill="#4285F4" d="M96 20C65.1 20 40 45.1 40 76c0 42 56 96 56 96s56-54 56-96c0-30.9-25.1-56-56-56z"/>
      <circle cx="96" cy="76" r="20" fill="#fff"/>
    </svg>
  );

  const actions = [
    {
      icon: null,
      IconComponent: GoogleMapsIcon,
      onClick: handleGoogleMaps,
      label: "Navigate",
      color: "#4285F4",
    },
    {
      icon: call,
      IconComponent: null,
      onClick: handleCall,
      label: "Call",
      color: "#4CAF50",
    },
    {
      icon: whatsapp,
      IconComponent: null,
      onClick: handleWhatsApp,
      label: "WhatsApp",
      color: "#25D366",
    },
  ];

  const getInitial = () => {
    return AllData.barberData.name?.charAt(0).toUpperCase() || "B";
  };

  return (
    <>
      <style>
        {`
          @keyframes float {
            0%, 100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-10px);
            }
          }

          .image-container:hover {
            transform: scale(1.05);
          }

          .action-button:active {
            transform: translateY(-2px) scale(0.98) !important;
          }

          .back-button:active,
          .share-button:active {
            transform: scale(0.95) !important;
          }

          @media (max-width: 768px) {
            .name {
              font-size: 24px !important;
            }
            
            .location {
              font-size: 13px !important;
            }
            
            .phone {
              font-size: 14px !important;
            }
            
            .profile-image {
              width: 120px !important;
              height: 120px !important;
            }

            .placeholder-avatar {
              width: 120px !important;
              height: 120px !important;
              font-size: 48px !important;
            }
            
            .action-button {
              width: 56px !important;
              height: 56px !important;
            }
            
            .button-icon {
              width: 32px !important;
              height: 32px !important;
            }

            .back-button {
              width: 44px !important;
              height: 44px !important;
              top: 16px !important;
              left: 16px !important;
            }

            .share-button {
              width: 44px !important;
              height: 44px !important;
              top: 70px !important;
              left: 16px !important;
            }
          }

          @media (max-width: 480px) {
            .name {
              font-size: 22px !important;
            }
            
            .location {
              font-size: 12px !important;
            }
            
            .buttons-container {
              gap: 16px !important;
            }

            .placeholder-avatar {
              width: 120px !important;
              height: 120px !important;
              font-size: 44px !important;
            }

            .back-button {
              width: 40px !important;
              height: 40px !important;
              top: 12px !important;
              left: 12px !important;
            }

            .share-button {
              width: 40px !important;
              height: 40px !important;
              top: 62px !important;
              left: 12px !important;
            }
          }
        `}
      </style>

      <div style={styles.container}>
        <button
          onClick={handleBack}
          style={styles.backButton}
          className="back-button"
          onMouseEnter={() => setBackHovered(true)}
          onMouseLeave={() => setBackHovered(false)}
          aria-label="Go Back"
        >
          <svg
            style={styles.backIcon}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
        </button>

        <button
          onClick={handleShare}
          style={styles.shareButton}
          className="share-button"
          onMouseEnter={() => setShareHovered(true)}
          onMouseLeave={() => setShareHovered(false)}
          aria-label="Share"
        >
          <svg
            style={styles.shareIcon}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
          </svg>
        </button>

        <div style={styles.backgroundOverlay} />
        <div style={styles.backgroundPattern} />

        <div style={styles.contentWrapper}>
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            <img
              src={Bokahitlogo2nobgc}
              alt="Bokahit"
              style={{
                height: windowWidth <= 1024 ? "35px" : "45px",
                objectFit: "contain",
              }}
            />
          </a>
          <div style={styles.imageContainer} className="image-container">
            {AllData.barberData.image ? (
              <img
                src={AllData.barberData.image}
                alt="Barber Profile"
                style={styles.profileImage}
                className="profile-image"
              />
            ) : (
              <div
                style={styles.placeholderAvatar}
                className="placeholder-avatar"
              >
                {getInitial()}
              </div>
            )}
          </div>

          <div style={styles.textContainer}>
            <h1 style={styles.name} className="name">
              {AllData.barberData.name}
            </h1>
            <p style={styles.location} className="location">
              📍 {address}
            </p>
          </div>

          <div style={styles.buttonsContainer} className="buttons-container">
            {actions.map((action, index) => (
              <button
                key={index}
                onClick={action.onClick}
                style={styles.actionButton(hoveredButton === index)}
                className="action-button"
                onMouseEnter={() => setHoveredButton(index)}
                onMouseLeave={() => setHoveredButton(null)}
                aria-label={action.label}
              >
                <div
                  style={{
                    ...styles.buttonRipple,
                    opacity: hoveredButton === index ? 1 : 0,
                  }}
                />
                {action.IconComponent ? (
                  <action.IconComponent />
                ) : (
                  <img
                    src={action.icon}
                    alt={action.label}
                    style={styles.buttonIcon}
                    className="button-icon"
                  />
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
